(() => {
  const initCard = (card) => {
    if (!card || card.dataset.edenCardReady === 'true') return;
    card.dataset.edenCardReady = 'true';

    const pills = [...card.querySelectorAll('[data-eden-variant], .eden-card__variant')];

    const priceNode =
      card.querySelector('[data-eden-card-price]') ||
      card.querySelector('.eden-card__price');

    const optionsLink =
      card.querySelector('[data-eden-options-link]') ||
      card.querySelector('.eden-card__options-button') ||
      card.querySelector('.eden-card__options');

    const selectVariant = (pill) => {
      if (!pill || pill.disabled) return;

      pills.forEach((item) => {
        const active = item === pill;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      const variantPrice =
        pill.dataset.variantPrice ||
        pill.dataset.price ||
        '';

      const variantUrl =
        pill.dataset.variantUrl ||
        pill.dataset.url ||
        '';

      if (priceNode && variantPrice) {
        priceNode.textContent = variantPrice;
      }

      if (optionsLink && variantUrl) {
        optionsLink.href = variantUrl;
      }
    };

    pills.forEach((pill) => {
      const stopAndSelect = (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        selectVariant(pill);
      };

      /* Capture phase is intentional:
         it prevents Dawn's full-card link overlay/navigation
         before bubbling handlers can run. */
      pill.addEventListener('click', stopAndSelect, true);

      pill.addEventListener(
        'keydown',
        (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            stopAndSelect(event);
          }
        },
        true
      );
    });
  };

  const init = (scope = document) => {
    if (scope.matches?.('[data-eden-collection-card]')) {
      initCard(scope);
    }

    scope
      .querySelectorAll?.('[data-eden-collection-card]')
      .forEach(initCard);
  };

  document.addEventListener('DOMContentLoaded', () => init(document));

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });

  window.addEventListener('pageshow', () => init(document));

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node instanceof Element) init(node);
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();